$( document ).ready( function() {
	$( ".faq__question" ).click( function() {
		$( this ).next().slideToggle();
		$( this ).parent().toggleClass( "faq__active" );
		$( ".faq__question" ).not( this ).next().slideUp();
		$( ".faq__question" ).not( this ).parent().removeClass( "faq__active" );
	} );
} );